import React, {PureComponent} from 'react';
import SmsCounter from 'sms-counter';
import {Picker} from 'emoji-mart';
import {Callout, Popover, PopoverInteractionKind, Position, Spinner} from "@blueprintjs/core";
import toastr from "toastr";
import {getCurrentUserId} from "../../services/authService";
import http from "../../services/httpService";
import {build} from "url-utm-params";
import {Switch as BlueprintSwitch} from "@blueprintjs/core/lib/esm/components/forms/controls";
import Loader from "../utils/loader";


export default class CampaignsTextArea extends PureComponent {
    state = {
        characterCount: 0,
        messagesCount: 1,
        messageContent: '',
        charsRemaining: 160,
        charsPerMessage: 160,
        rows: 5,
        minRows: 5,
        maxRows: 20,
        emojiActive: false,
        pauseClosing: false,
        personalize: this.props.personalize ? this.props.personalize : false,
        plan: this.props.plan ? this.props.plan : '',
        personalizeParameters: [],
        viberChars: 0,
        initialContentLoaded: false,
        selectedSourceFull: this.props.selectedSourceFull, //contenteditable parameters

        //url trackable link states

        loading: false,
        longUrl: '',
        longUrlUtm: '',
        selectedDomain: 'https://oo.fyi/t/',
        title: '',
        shortenedUrl: '', //shortCode: '',
        utmSource: '',
        utmMedium: '',
        utmCampaign: '',
        utmContent: '',
        utmTerm: '',
        customName: '',
        customValue: '',
        utmTracking: false,
        freeMessages: '',
        clipboard: 0,
        selectedSource: this.props.selectedSource,
        cursorPosition: this.props.cursorPosition ? this.props.cursorPosition : 0
    };


    toggleEmoji = async (e) => {

        //console.log('target: ', e.target);
        let clickedElement = e.target
        let emojiMart = document.querySelector('.emoji-mart');

        if (!emojiMart.contains(clickedElement)) {

            await this.setState({
                emojiActive: !this.state.emojiActive, pauseClosing: !this.state.pauseClosing
            });

            setTimeout(() => this.setState({pauseClosing: false}), 500)
        }
    };


    setNativeValue = (element, value) => {
        const valueSetter = Object.getOwnPropertyDescriptor(element, 'value').set;
        const prototype = Object.getPrototypeOf(element);
        const prototypeValueSetter = Object.getOwnPropertyDescriptor(prototype, 'value').set;

        if (valueSetter && valueSetter !== prototypeValueSetter) {
            prototypeValueSetter.call(element, value);
        } else {
            valueSetter.call(element, value);
        }
    }

    handleEmoji = async (e) => {

        let messageContentBeforeCaret = this.state.messageContent.substring(0, this.state.cursorPosition)
        let messageContentAfterCaret = this.state.messageContent.slice(this.state.cursorPosition)
        let newMessageContent = messageContentBeforeCaret + e.native + messageContentAfterCaret;

        await this.props.onUpdate(newMessageContent);
        await this.setState({
            messageContent: newMessageContent, characterCount: this.state.characterCount + e.native.length,

        });

        this.props.updateCursorPosition(e.native.length)
        this.handleMessageContent(newMessageContent);
    };

    handleMessageContent = (message) => {
        //console.log('value changed');
        const textareaLineHeight = 18;
        const {minRows} = this.state;
        const textarea = document.querySelector('#' + this.props.uniqueId);
        const previousRows = textarea.rows;
        const maxRows = this.state.maxRows;
        //console.log('previous rows: ', previousRows)

        textarea.rows = minRows; // reset number of rows in textarea
        //console.log('textarea.scrollHeight: ', textarea.scrollHeight)
        let currentRows = ~~((textarea.scrollHeight - 20) / textareaLineHeight);
        // if (currentRows >= maxRows){
        //     currentRows = maxRows
        // }
        //console.log('current rows: ', currentRows);
        if (currentRows === previousRows) {
            textarea.rows = currentRows;
        }
        //console.log('current rows: ', currentRows);

        this.setState({
            rows: currentRows,
            maxRows: currentRows,
            messageContent: message,
            characterCount: SmsCounter.count(message).length,
            messagesCount: SmsCounter.count(message).messages,
            charsRemaining: SmsCounter.count(message).remaining,
            charsPerMessage: SmsCounter.count(message).per_message,
        })
        this.props.onUpdate(message)
    }

    closeEmojiMart = (e) => {

        let clickedElement = e.target;
        if (document.querySelector('.emoji-mart')) {
            let emojiMart = document.querySelector('.emoji-mart');
            let emojiToggle = document.querySelector('.emoji-selector-container');
            if (!emojiMart.contains(clickedElement)) {
                if ((clickedElement !== emojiToggle) && !this.state.pauseClosing) {
                    //console.log('close emoji');
                    this.setState({emojiActive: false})
                }
            }
        }

    };
    handlePersonalize = async (e) => {

        let cursorPosition = this.state.cursorPosition
        let messageContentBeforeCaret = this.state.messageContent.substring(0, this.state.cursorPosition)
        let messageContentAfterCaret = this.state.messageContent.slice(this.state.cursorPosition)

        let messageLength = this.state.messageContent.length
        let messageFirstPart = this.state.messageContent.substr(0, cursorPosition)
        //console.log('messageFirstPart: ', messageFirstPart)
        let messageSecondPart = this.state.messageContent.substr(cursorPosition, messageLength)
        //console.log('messageSecondPart: ', messageSecondPart)
        //console.log('personalize handle: ', e.target.getAttribute('value'));
        let personalizationTag = e.target.getAttribute('value')
        let newMessageContent = messageContentBeforeCaret + ' {' + personalizationTag + '} ' + messageContentAfterCaret;

        await this.setState({
            messageContent: newMessageContent,
            characterCount: this.state.characterCount + e.target.getAttribute('value').length + 6,
            cursorPosition: cursorPosition + personalizationTag.length
        })
        this.handleMessageContent(newMessageContent);
        this.props.updateCursorPosition(personalizationTag.length + 6)

    };

    generateTrackableLink = async () => {


        if (this.state.longUrl !== '') {
            toastr.info('Creating in progress...');
            this.setState({
                loading: true
            })
            let URL_META = await this.state.longUrl;
            let n = await URL_META.startsWith('http');
            let UTM_URL = this.state.longUrlUtm;

            if (n === false) {
                URL_META = 'http://' + URL_META;
                UTM_URL = 'http://' + this.state.longUrlUtm;
            }
            await this.setState({
                longUrl: URL_META, longUrlUtm: UTM_URL
            });

            let domainFormat = ''
            if (this.state.selectedDomain === 'https://oo.fyi/t/') {
                domainFormat = 'oo'
            } else {
                domainFormat = 's'
            }
            let params = {
                url: this.state.plan === 'free_plan' ? this.state.longUrl : this.state.utmTracking ? this.state.longUrlUtm : this.state.longUrl,
                title: this.state.title || ' ',
                project_id: this.state.selectedSource,
                user_id: getCurrentUserId(),
                domain_format: domainFormat
            };

            try {
                // console.log('params: ', params)
                //console.log('shortening call: ', 'https://short.emitto.io/create')

                const response = await http.post('https://short.emitto.io/create', params
                    //,
                    // {
                    // headers: {
                    //     authorization: getJwt(),
                    //     'Access-Control-Allow-Origin': '*'
                    // }
                    //}
                )
                    .then(function (response) {
                        //console.log('fetch response: ', response)
                        return response;
                    })
                    .then(function (data) {
                        //console.log('shortening response: ', items)
                        return data;
                    })

                //console.log('shortening response: ', response.data);
                // preventDefault()
                //let shortCode = response.data.replace(this.state.selectedDomain, '')
                let cursorPosition = this.state.cursorPosition
                let messageLength = this.state.messageContent.length
                let messageFirstPart = this.state.messageContent.substring(0, cursorPosition)
                //console.log('messageFirstPart: ', messageFirstPart)
                let messageSecondPart = this.state.messageContent.substring(cursorPosition, messageLength)
                //console.log('messageSecondPart: ', messageSecondPart)
                //console.log('personalize handle: ', e.target.getAttribute('value'));
                let newMessageContent = messageFirstPart + " " + response.data + " " + messageSecondPart;

                await this.setState({
                    shortenedUrl: response.data, //      shortCode: response,
                    loading: false,
                    messageContent: newMessageContent,
                    cursorPosition: cursorPosition + response.data.length + 3
                });
                this.props.updateCursorPosition(response.data.length + 3)
                toastr.success('Link added to message!')
                this.props.onUpdate(this.state.messageContent)
            } catch (e) {
                console.log('shorten link response error')

                // event.preventDefault();
                //console.log(e)
                toastr.error('Something went wrong... Please try again.');
                this.setState({
                    loading: false
                })
            }

//decrease freeMessages

// try {
//     console.log('decrease call: ', '/api/user/' + this.props.user.id + '/project/' + this.state.selectedSource + '/decrease_url')
//
//     const decreaseResponse = await http.patch('/api/user/' + this.props.user.id + '/project/' + this.state.selectedSource + '/decrease_url',
//         {},
//         {
//             headers: {
//                 authorization: getJwt()
//             }
//         });
//
//     // console.log('decreaseResponse: ', decreaseResponse)
//     //console.log('remainingMessages: ', decreaseResponse.data.free_messages_remaining);
//     this.setState({
//         freeMessages: decreaseResponse.data.free_messages_remaining
//     })
// } catch (e) {
//     console.log('decrease error')
//
//     //console.log(e)
//     toastr.error('Something went wrong... Please try again.');
//     this.setState({
//         loading: false
//     })
// }
        } else {
            toastr.error("URL field can't be empty.")
        }

    };
    handleInput = async (e) => {
        //console.log('input id: ', e.target.id);

        await this.setState({
            [e.target.id]: e.target.value
        });

        if (this.state.longUrl !== '') {
            this.handleCampaign()
        } else {
            await this.setState({
                longUrlUtm: ''
            })
        }
    };

    handleCampaign = async () => {
        let params = {
            utm_source: this.state.utmSource,
            utm_medium: this.state.utmMedium,
            utm_campaign: this.state.utmCampaign,
            utm_content: this.state.utmContent,
            utm_term: this.state.utmTerm,

        };

        if (this.state.customName.length > 0) {
            params[this.state.customName] = this.state.customValue;
        }
        //console.log('params: ', params);


        //cleaning empty params
        Object.keys(params).map((keyName, i) => {
            if (params[keyName] === '') {
                delete params[keyName]
            }
        });


        //console.log('new params: ', params);
        let longUrlUtm = '';

        if (this.state.utmTracking === true) {
            longUrlUtm = await build(this.state.longUrl, params, false)
        } else {
            longUrlUtm = await this.state.longUrl
        }
        await this.setState({
            longUrlUtm
        })
    };
    toggleEnableUTM = async () => {

        let utmTracking = !this.state.utmTracking;

        await this.setState({utmTracking});
        let params = {
            utm_source: this.state.utmSource,
            utm_medium: this.state.utmMedium,
            utm_campaign: this.state.utmCampaign,
            utm_content: this.state.utmContent,
            utm_term: this.state.utmTerm,

        };

        if (this.state.customName.length > 0) {
            params[this.state.customName] = this.state.customValue;
        }
        //console.log('params: ', params);


        //cleaning empty params
        Object.keys(params).map((keyName, i) => {
            if (params[keyName] === '') {
                delete params[keyName]
            }
        });


        //console.log('new params: ', params);
        let longUrlUtm = '';

        if (this.state.utmTracking === true) {
            longUrlUtm = this.state.longUrl.length > 0 ? await build(this.state.longUrl, params, false) : ''
        } else {
            longUrlUtm = this.state.longUrl.length > 0 ? await this.state.longUrl : ''
        }
        //console.log('longUrlUtm: ', longUrlUtm)

        this.setState({
            longUrlUtm
        })
    };

    getProjectShortenedData = async () => {
        if (this.state.longUrl !== '') {
            try {
                const result = await http.get("https://short.emitto.io/project/" + this.props.selectedSource);
                //console.log("result.data.data", result);
            } catch (e) {
                toastr.error(e);
            }
        }
    };
    switchOnChange = () => {
        //console.log('changed');
    }
    copyToClipboard = () => {
        //console.log('shortenedURL: ', document.querySelector('#shortenedUrl').value);
        const myInp = document.getElementById('shortenedUrl');
        myInp.select();
        document.execCommand('Copy')
        this.setState({
            clipboard: 1
        })
        toastr.success('Link copied to clipboard!')
    }

    componentDidMount = async () => {
        document.addEventListener("click", this.closeEmojiMart);
        let selectedSourceFull = ''
        if (this.state.user) {
            selectedSourceFull = await this.state.user.sources.data.filter(source => source.id.toString() === this.props.selectedSource)
            // console.log('props: ', this.props)
            if (selectedSourceFull[0]) {
                let urlPlatform = selectedSourceFull[0].platforms.filter(platform => platform.platform === 'url')
                //console.log('url platform :', urlPlatform);


                await this.setState({
                    plan: selectedSourceFull[0] ? selectedSourceFull[0].platforms[0].plan : '',
                    freeMessages: urlPlatform[0] ? urlPlatform[0].free_messages_remaining : this.state.freeMessages
                })
            }
        }
        if (this.props.messageContent) {
            this.setState({messageContent: this.props.messageContent, initialContentLoaded: true})
        }
    }

    componentDidUpdate = () => {
        if (this.state.personalize !== this.props.personalize) {
            // console.log('emoji prop changed: ', this.props.personalize);
            this.setState({
                personalize: this.props.personalize

            })

        }
        if (this.state.plan !== this.props.plan) {

            this.setState({
                plan: this.props.plan
            })
        }
        if (this.props.messageContent && !this.state.initialContentLoaded) {
            this.setState({messageContent: this.props.messageContent, initialContentLoaded: true})
        }
        if (this.state.selectedSource !== this.props.selectedSource) {
            this.setState({
                selectedSource: this.props.selectedSource, messageContent: ''
            })
        }
        if (this.state.cursorPosition !== !this.props.cursorPosition) {
            this.setState({
                cursorPosition: this.props.cursorPosition
            })
        }
        if (this.state.selectedSourceFull !== this.props.selectedSourceFull) {
            this.setState({
                selectedSourceFull: this.props.selectedSourceFull
            })
        }
    }

    render() {
        const {
            label,
            placeholder,
            height,
            maxCharacters,
            infoCircleType,
            infoCircleContent,
            showMessagesNumber,
            uniqueId,
            viber
        } = this.props;
        const personalizeValues = ['first_name', 'last_name', 'full_name'];

        const textarea = document.querySelector('textarea');
        return (<div className="form-group primary-text message-textarea">
            <div className='emoji-textarea-title display-flex justify-content-space'>
                    <span>{label}
                        {/*<InfoCircle*/}
                        {/*    icon={infoCircleType === 'question' ? 'question' : ''}*/}
                        {/*    infoCircleContent={infoCircleContent}*/}
                        {/*/>*/}
                    </span>
                <div className='flex-direction-row'>
                    {viber ? <p className='character-count'>Characters:<span>
                                {this.state.characterCount + '/' + maxCharacters}
                            </span>
                    </p> : <React.Fragment>
                        <p className='character-count'>Characters:<span>
                                    {showMessagesNumber ? (this.state.characterCount + '/' + this.state.charsPerMessage * this.state.messagesCount) : (this.state.characterCount + '/' + maxCharacters)}
                            {/*{this.state.charsRemaining}/{showMessagesNumber ? this.state.charsRemaining : maxCharacters}*/}
                                </span>
                        </p>

                        {showMessagesNumber ? <p className='character-count'> Messages: <span>
                                        {this.state.messagesCount}
                                    </span>
                        </p> : ''}
                    </React.Fragment>}
                </div>
            </div>
            <React.Fragment>
                                    <textarea

                                        rows={this.state.rows}
                                        value={this.state.messageContent}
                                        className={this.state.characterCount ? 'post-message-text valid' : 'post-message-text'}
                                        // id='sms-fallback-message-text'
                                        maxLength={this.props.viber ? 1000 : showMessagesNumber ? (6 * this.state.charsPerMessage) : maxCharacters}
                                        // style={{minHeight: height}}
                                        placeholder={placeholder}
                                        id={uniqueId}
                                        onChange={(e) => {
                                            this.handleMessageContent(e.target.value)
                                        }}
                                        onClick={this.props.onClick}
                                    >
                                    </textarea>
                <div className="message-options flex-wrap">
                    <div className='emojis-personalize'>
                        <div className="emoji-selector-container" onClick={e => this.toggleEmoji(e)}>
                            <span className='far fa-smile'></span>
                            <span className='caption'>Insert Emoji</span>
                            <Picker
                                autoFocus={true}
                                // native={ this.state.native }
                                style={{display: this.state.emojiActive ? 'block' : 'none'}}
                                onClick={(e) => {
                                    this.handleEmoji(e)
                                }}
                            />
                        </div>

                        {this.state.personalize && this.state.selectedSourceFull && this.props.selectedRecipient !== 'Add Manually' ?

                            <div className="personalize-options">
                                {this.state.selectedSourceFull.custom_plan !== '' && this.state.selectedSourceFull.custom_plan.additional_features && this.state.selectedSourceFull.custom_plan.additional_features.personalization ? this.state.selectedSourceFull.custom_plan.additional_features.personalization === 1 ?
                                        <Popover
                                            interactionKind={PopoverInteractionKind.CLICK}
                                            position={Position.BOTTOM}
                                            minimal={true}

                                        >
                                            <div className='flex-direction-row'
                                                 onClick={this.checkSel}
                                            >
                                                <span className="personalize-icon"></span>
                                                Personalize
                                            </div>

                                            <ul className='personalize-popover-content'>
                                                {personalizeValues.map(personalizationTag => {
                                                    return <li key={personalizationTag}
                                                               onClick={(e) => this.handlePersonalize(e)}
                                                               value={personalizationTag}>{personalizationTag}</li>
                                                })}
                                            </ul>

                                        </Popover>

                                        :

                                        <div className='flex-direction-row'
                                             onClick={this.props.triggerUpsellModal}>
                                            <span className="personalize-icon"></span>
                                            Personalize
                                        </div>

                                    :

                                    this.state.selectedSourceFull.plan.additional_features.personalization === 1 ?
                                        <Popover
                                            interactionKind={PopoverInteractionKind.CLICK}
                                            position={Position.BOTTOM}
                                            minimal={true}

                                        >
                                            <div className='flex-direction-row'
                                                 onClick={this.checkSel}
                                            >
                                                <span className="personalize-icon"></span>
                                                Personalize
                                            </div>

                                            <ul className='personalize-popover-content'>
                                                {personalizeValues.map(personalizationTag => {
                                                    return <li key={personalizationTag}
                                                               onClick={(e) => this.handlePersonalize(e)}
                                                               value={personalizationTag}>{personalizationTag}</li>
                                                })}
                                            </ul>

                                        </Popover> : <div className='flex-direction-row'
                                                          onClick={this.props.triggerUpsellModal}>
                                            <span className="personalize-icon"></span>
                                            Personalize
                                        </div>

                                }

                            </div>

                            :

                            ''}
                        {window.location.pathname === '/new/sms' || window.location.pathname === '/new/viber' ? <Popover
                            interactionKind={PopoverInteractionKind.CLICK}
                            position={Position.BOTTOM}
                            minimal={true}
                            className='trackable-link-popover'
                        >
                            <div className='trackable-link-title'>
                                <i className="fas fa-link"></i>
                                <span className="caption"> Trackable link</span>
                            </div>
                            <div
                                className={window.location.href.indexOf("unified-inbox") > -1 ? 'trackable-link-content trackable-link-content-inbox padding-10' : 'trackable-link-content padding-10'}>
                                <h3 className='all-caps grey-text'>Trackable link</h3>
                                <div className="form-group m-m-b primary-text">
                                    <label className='full-row-label'>Base URL</label>
                                    <textarea autoFocus={true} id='longUrl'
                                              onChange={(e) => this.handleInput(e)}
                                              className='post-message-text'
                                              placeholder='Enter the link you’d like to shorten'
                                              rows={2}
                                              value={this.state.longUrl}
                                    />
                                </div>
                                <div className="utm-settings">
                                    <BlueprintSwitch
                                        checked={this.state.utmTracking}
                                        label="Add UTM Tags"
                                        onClick={this.toggleEnableUTM}
                                        onChange={this.switchOnChange}
                                    />
                                    {this.state.utmTracking === true ?

                                        <React.Fragment>
                                            {this.state.plan === 'free_plan' ? <Callout
                                                intent='primary'
                                                icon='info-sign'
                                            >
                                                UTM Tags are a Premium Feature. <br></br>
                                                To gain access <a
                                                className='upgrade-now'
                                                href="#"
                                                onClick={this.props.upgradeModalActivate}>Upgrade Now.</a>
                                            </Callout> : ''}

                                            <div className="form-group m-m-b">
                                                <label className='full-row-label'>Campaign Name</label>
                                                <input id='utmCampaign'
                                                       value={this.state.utmCampaign}
                                                       onChange={(e) => this.handleInput(e)}
                                                       placeholder='ex. Emitto'
                                                       className='fb-sponsored-message-input'
                                                       type="text"/>
                                            </div>
                                            <div className="form-group m-m-b">
                                                <label className='full-row-label'>Campaign Source</label>
                                                <input id='utmSource' value={this.state.utmSource}
                                                       onChange={(e) => this.handleInput(e)}
                                                       placeholder='ex. Marketing'
                                                       className='fb-sponsored-message-input'
                                                       type="text"/>
                                            </div>
                                            <div className="form-group m-m-b">
                                                <label className='full-row-label'>Campaign Medium</label>
                                                <input id='utmMedium' placeholder='ex. facebook'
                                                       value={this.state.utmMedium}
                                                       onChange={(e) => this.handleInput(e)}
                                                       className='fb-sponsored-message-input'
                                                       type="text"/>
                                            </div>
                                        </React.Fragment> :

                                        ''}
                                    <div className="display-flex button-title-container">
                                        <div className="form-group m-m-b">
                                            <label className='full-row-label'>Title</label>
                                            <input id='title'
                                                   placeholder='Add title for easier differentiation between links'
                                                   onChange={(e) => this.handleInput(e)}
                                                   className='fb-sponsored-message-input'
                                                   type="text"
                                                   value={this.state.title}
                                            />
                                        </div>
                                        <button
                                            onClick={this.state.freeMessages === 0 ? this.noMessagesRemaining : this.state.plan === 'free_plan' && this.state.utmTracking ? this.props.upgradeModalActivate : this.generateTrackableLink}
                                            className='btn-action'
                                            disabled={this.state.loading ? true : ''}
                                        >
                                            Generate Trackable Link
                                            {this.state.loading ? <i className='fa fa-spin fa-spinner'></i> : ""}
                                        </button>

                                    </div>
                                    {this.state.shortenedUrl !== '' ? <React.Fragment>
                                        <div className="form-group">
                                            <label className='full-row-label'>
                                                Shortened Website URL
                                            </label>
                                            <input readOnly={true} id='shortenedUrl'
                                                   value={this.state.shortenedUrl}
                                                   onChange={(e) => this.handleInput(e)}
                                                   className='fb-sponsored-message-input'
                                                   type="text"/>
                                        </div>
                                        <div className='clipboard-button-container'>
                                            <button onClick={this.copyToClipboard} id='copy'
                                                    className='btn-action'>
                                                Copy to Clipboard
                                            </button>
                                        </div>
                                    </React.Fragment> : ''}
                                </div>
                            </div>
                        </Popover> : ''}
                    </div>

                </div>
            </React.Fragment>
        </div>)
    }
}